import { COMPATIBLE_LLM_MODEL_TYPES } from 'modules/Playground/Components/PlaygroundModelSelector/ModelSelectorConstants';
import { useQuery } from 'react-query';
import { ApiModel, V2 } from 'types/swagger/clarifai-api';
import { queryKeys } from 'utils/react-query';
import { getFeaturedModels } from '../getFeaturedModels';

export const useFeaturedModels = (initialData?: V2.V2ListModels3.ResponseBody) => {
  const query = useQuery(
    [queryKeys.Models, { featured: true }],
    async () => {
      return getFeaturedModels();
    },
    {
      initialData,
    },
  );

  return query.data?.models?.filter(ensureCompatibleModelTypes);
};

const ensureCompatibleModelTypes = (model: ApiModel): boolean => {
  if (!model.model_type_id) return false;
  return COMPATIBLE_LLM_MODEL_TYPES.includes(model.model_type_id);
};
